import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import { Grid, IconButton } from '@mui/material'
import { CONSTANTS } from '../../../Constants/Constant'
import RedCrossIcon from '../../Icons/RedCrossIcon'
import MUIButton from '../MUI-Button'
import MUIFieldWithoutControl from '../MUI-Field-Without-Control'
import MUIMultiselectAsset from '../MUI-Multiselect-Asset/MUI-Multiselect-Asset'
import MUITooltip from '../MUI-Tooltip'

const JSONInputField1: React.FC<any> = ({
  fieldId,
  index,
  label,
  error,
  fields,
  addMore,
  addMoreRemoveAction,
  formFieldsOptions,
  onInputChange,
  showAddmoreIcon = false,
}: any) => {
  const getErrorObject = (item: any) => {
    if (!item.errorMessage) return {}
    return { [item.fieldName]: { message: item.errorMessage } }
  }
  return (
    <>
      {fields?.map((fieldsArray: any, fieldsIndex: number) =>
        !showAddmoreIcon ? (
          <div
            key={`json-input-${fieldId}-${fieldsIndex}`} // NOSONAR
            className='partner-asset-type-config-wrapper'
          >
            <div className='text-left config-title'>
              <p className='center-vertical'>
                {label} {fields?.length > 1 ? fieldsIndex + 1 : ''}
              </p>
              {fields?.length > 1 && !showAddmoreIcon && (
                <div
                  className='ml-auto cursor-pointer red-cross-icon'
                  onClick={() => addMoreRemoveAction('', index, fieldsIndex, false, fieldId)}
                  data-testid='remove-json1-field'
                >
                  <RedCrossIcon />
                </div>
              )}
            </div>
            <div className='config-form'>
              <Grid container columnSpacing={10} rowSpacing={4}>
                {fieldsArray.map((field: any, fieldIndex: number) => {
                  let options = field?.options
                  if (
                    field?.formFieldsOptionsKey &&
                    formFieldsOptions[field.formFieldsOptionsKey]
                  ) {
                    options = formFieldsOptions[field.formFieldsOptionsKey]
                  }
                  const isSelectField = field?.fieldType === CONSTANTS.FIELDTYPES.SELECT
                  return (
                    <Grid
                      item
                      xs={6}
                      md={6}
                      lg={6}
                      xl={6}
                      key={`${field?.fieldName}-${fieldsIndex}-${fieldIndex}`}
                    >
                      {isSelectField ? (
                        <MUIMultiselectAsset
                          id={field?.fieldName}
                          name={field?.fieldName}
                          className='autocomple-class'
                          multiple={field?.isMultiple}
                          label={field?.label}
                          options={options}
                          value={field?.value}
                          labelKey={field?.labelKey}
                          required={field?.validations?.required}
                          error={getErrorObject(field)}
                          onInputChange={(_ev: any, newValue: any) => {
                            onInputChange({
                              ev: newValue,
                              index,
                              item: field,
                              fieldsIndex,
                              fieldIndex,
                            })
                          }}
                        />
                      ) : (
                        <MUIFieldWithoutControl
                          name={field?.fieldName}
                          type={field?.fieldType}
                          error={getErrorObject(field)}
                          label={field?.label}
                          placeholder={field?.label}
                          value={field?.value}
                          required={field?.validations?.required}
                          onChange={(ev: any) => {
                            onInputChange({
                              ev,
                              index,
                              item: field,
                              fieldsIndex,
                              fieldIndex,
                            })
                          }}
                        />
                      )}
                    </Grid>
                  )
                })}
              </Grid>
            </div>
          </div>
        ) : (
          <div
            key={`json-input-${fieldId}-${fieldsIndex}`} // NOSONAR
            className='complex-config-wrapper'
          >
            {(() => {
              const isCompactGrid = fieldsArray?.length >= 4
              return (
                <>
                  {fieldsIndex === 0 ? (
                    <>
                      <div className='text-left config-title'>
                        <p>{label}</p>
                      </div>
                      {error ? (
                        <div className='text-left config-title field-error'>{error}</div>
                      ) : null}
                    </>
                  ) : (
                    <></>
                  )}

                  <Grid
                    container
                    columnSpacing={isCompactGrid ? 2 : 5}
                    rowSpacing={4}
                    columns={isCompactGrid ? 13 : 12}
                    wrap={isCompactGrid ? 'nowrap' : 'wrap'}
                    alignItems={isCompactGrid ? 'center' : undefined}
                    className=''
                    sx={isCompactGrid ? { '& .MuiGrid-item': { minWidth: 0 } } : {}}
                  >
                    {fieldsArray.map((field: any, fieldIndex: number) => {
                      let options = field?.options
                      if (
                        field?.formFieldsOptionsKey &&
                        formFieldsOptions[field.formFieldsOptionsKey]
                      ) {
                        options = formFieldsOptions[field.formFieldsOptionsKey]
                      }
                      const isSelectField = field?.fieldType === CONSTANTS.FIELDTYPES.SELECT
                      const showRequired =
                        field?.showRequired !== false && field?.validations?.required
                      return (
                        <Grid
                          item
                          xs={isCompactGrid ? 3 : 4.9}
                          md={isCompactGrid ? 3 : 4.9}
                          lg={isCompactGrid ? 3 : 4.9}
                          xl={isCompactGrid ? 3 : 4.9}
                          key={`${field?.fieldName}-${fieldsIndex}-${fieldIndex}`}
                        >
                          {isSelectField ? (
                            <MUIMultiselectAsset
                              id={field?.fieldName}
                              name={field?.fieldName}
                              className='autocomple-class'
                              multiple={field?.isMultiple}
                              label={field?.label}
                              options={options}
                              value={field?.value}
                              labelKey={field?.labelKey}
                              required={showRequired}
                              error={getErrorObject(field)}
                              onInputChange={(_ev: any, newValue: any) => {
                                onInputChange({
                                  ev: newValue,
                                  index,
                                  item: field,
                                  fieldsIndex,
                                  fieldIndex,
                                })
                              }}
                            />
                          ) : (
                            <MUIFieldWithoutControl
                              name={field?.fieldName}
                              type={field?.fieldType}
                              error={getErrorObject(field)}
                              label={field?.label}
                              placeholder={field?.label}
                              value={field?.value}
                              required={showRequired}
                              onChange={(ev: any) => {
                                onInputChange({ ev, index, item: field, fieldsIndex, fieldIndex })
                              }}
                            />
                          )}
                        </Grid>
                      )
                    })}

                    <Grid
                      item
                      xs={isCompactGrid ? 1 : 0.5}
                      md={isCompactGrid ? 1 : 0.5}
                      lg={isCompactGrid ? 1 : 0.5}
                      xl={isCompactGrid ? 1 : 0.5}
                      className='center-vertical'
                      sx={
                        isCompactGrid
                          ? { display: 'flex', justifyContent: 'center', alignItems: 'center' }
                          : {}
                      }
                    >
                      {fieldsIndex === 0 ? (
                        <IconButton
                          className='icon-button'
                          data-testid='add__icon_complextype'
                          onClick={() => addMoreRemoveAction('', index, null, true, fieldId)}
                          sx={isCompactGrid ? { p: 0.25 } : {}}
                        >
                          <MUITooltip title='Add New Value' disableInteractive={true}>
                            <AddCircleOutlineIcon sx={isCompactGrid ? { fontSize: 32 } : {}} />
                          </MUITooltip>
                        </IconButton>
                      ) : (
                        <IconButton
                          className='icon-button'
                          data-testid='remove__icon_complextype'
                          onClick={() =>
                            addMoreRemoveAction('', index, fieldsIndex, false, fieldId)
                          }
                          sx={isCompactGrid ? { p: 0.25 } : {}}
                        >
                          <MUITooltip title='Remove Value' disableInteractive={true}>
                            <RemoveCircleOutlineIcon sx={isCompactGrid ? { fontSize: 32 } : {}} />
                          </MUITooltip>
                        </IconButton>
                      )}
                    </Grid>
                  </Grid>
                </>
              )
            })()}
          </div>
        ),
      )}

      {addMore && !showAddmoreIcon && (
        <Grid key={`json-input-${fieldId}`} item xs={12} className='d-flex justify-content-end'>
          <MUIButton
            width={160}
            height='48px'
            textTransform={'capitalize'}
            variant='outlined'
            size='large'
            color={'secondary'}
            type='button'
            label={'+ Add More'}
            handleClickCB={() => addMoreRemoveAction('', index, null, true, fieldId)}
          />
        </Grid>
      )}
    </>
  )
}
export default JSONInputField1
